<template>
  <div class="app-container">
    <div class="control-client-top">
      <!-- <div class="detailsTitle">
        <h4>控货客户配置</h4>
      </div> -->
      <div>
        <div class="formBox margbot" ref="searchBox">
          <el-form inline style="padding-left: 10px;">
            <el-form-item label="一级货主:">
              <el-select
                v-model="searchForm.oneCustomerTaxId"
                size="mini"
                filterable
                placeholder="请选择一级货主"
                clearable
              >
                <el-option
                  v-for="(item, index) in FOwnerData"
                  :key="index"
                  :label="item.custerName"
                  :value="item.taxpayerNumber"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="二级货主:">
              <el-select
                v-model="searchForm.twoCustomerTaxId"
                size="mini"
                filterable
                placeholder="请选择二级货主"
                clearable
              >
                <el-option
                  v-for="(item, index) in FOwnerData"
                  :key="index"
                  :label="item.custerName"
                  :value="item.taxpayerNumber"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <br />
            <el-form-item style="padding: 0 0 5px 0;">
              <el-button
                type="primary"
                @click="chaxun"
                size="mini"
                btnCode="00FP00AB001"
                v-if="btnFlg[0]"
                >查询</el-button
              >
              <el-button
                type="primary"
                @click="chongzhi"
                size="mini"
                btnCode="00FP00AB002"
                v-if="btnFlg[1]"
                >重置</el-button
              >
              <el-button
                type="primary"
                @click="xinzeng"
                size="mini"
                btnCode="00FP00AB003"
                v-if="btnFlg[2]"
                >新增</el-button
              >
              <el-button
                type="primary"
                @click="shanchu"
                size="mini"
                btnCode="00FP00AB004"
                v-if="btnFlg[3]"
                :loading= deleteButtonOnLoading
                >删除</el-button>
                <!-- 山西美景-删除 -->
                <el-button
                type="primary"
                @click="deletedClick"
                size="mini"
                btnCode="00FP00AB006"
                v-if="btnFlg[5]"
                >删除</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <div :style="{ height: h }">
      <el-table
        ref="table"
        size="mini"
        :data="tableData"
        highlight-current-row
        :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
        @row-click="dianjixuanzhong"
        height="100%"
        style="width: 100%"
        border
        center
        bordersize="mini"
        class="tableComent"
      >
        <el-table-column
          type="index"
          label="序号"
          align="center"
          width="60"
        ></el-table-column>
        <el-table-column
          label="一级货主"
          prop="oneCustomerName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="二级货主"
          prop="twoCustomerName"
          align="center"
        ></el-table-column>
        <el-table-column
          label="控货配置"
          prop="secondaryCustomerName"
          align="center"
        >
          <template slot-scope="scope1">
            <el-button
              @click="seeClick(scope1.row)"
              type="text"
              size="small"
              btnCode="00FP00AB005"
              v-if="btnFlg[4]"
              >查看</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="createUser"
          label="创建人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          :formatter="dateTimeFormat"
        ></el-table-column>
      </el-table>
    </div>
    <div class="pags" style="text-align: left">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :current-page="searchForm.pageNo"
        :page-size="searchForm.pageSize"
        :page-sizes="[10, 20, 30, 40, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 新增 -->
    <el-dialog
      title="新增控货客户"
      :visible.sync="XZVisible"
      :close-on-click-modal="false"
      width="55%"
      center
      @close="closeXZDialog('XzForm')"
    >
      <el-form
        :model="XzForm"
        ref="XzForm"
        label-width="110px"
        class="demo-dynamic"
        :rules="rulesXz"
      >
        <el-form-item
          prop="primaryCustomerTaxId"
          label="一级货主"
          style="margin-bottom: 18px"
        >
          <el-select
            v-model="XzForm.primaryCustomerTaxId"
            size="mini"
            filterable
            style="width: 200px"
            placeholder="请选择一级货主"
          >
            <el-option
              v-for="(item, index) in FOwnerData"
              :key="index"
              :label="item.custerName"
              :value="item.taxpayerNumber"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          prop="secondaryCustomerId"
          label="二级货主"
          style="margin-bottom: 18px"
        >
          <el-select
            v-model="XzForm.secondaryCustomerId"
            size="mini"
            filterable
            style="width: 200px"
            placeholder="请选择二级货主"
          >
            <el-option
              v-for="(item, index) in FOwnerData"
              :key="index"
              :label="item.custerName"
              :value="item.taxpayerNumber"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 选择货物类型，控货指标、控货程度隐藏，货物类型显示
     选择其他货物类型隐藏，控货指标、控货程度显示 -->
        <el-form-item
          prop="weiDuArr"
          label="控货纬度"
          style="margin-bottom: 18px"
        >
          <el-checkbox-group v-model="XzForm.weiDuArr" @change="checkedWeiDu()">
            <el-checkbox
              v-for="item in checkWeiDuData"
              :key="item.itemNo"
              :label="item.itemNo"
              >{{ item.showName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          prop="zhiBiaoArr"
          label="控货指标"
          style="margin-bottom: 18px"
          v-if="zhiBIaoshow"
        >
          <el-checkbox-group v-model="XzForm.zhiBiaoArr" @change=controlIndexChange()>
            <el-checkbox
              v-for="(item, index) in checkZhiBiaoData"
              :key="index"
              :label="item.itemNo"
              >{{ item.showName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item
          prop="kongDun"
          label="控吨程度"
          style="margin-bottom: 25px"
          v-if="kongDunShow"
        >
          <el-radio-group v-model="XzForm.kongDun">
            <el-radio label="0">严控</el-radio>
            <el-radio label="1">提示</el-radio>
          </el-radio-group>
        </el-form-item>
        <div v-if="huoWuTypeShow">
          <div style="margin: 12px 0 13px 40px; display: flex">
            <div>货物类型</div>
            <el-button
              @click="addtable"
              type="primary"
              size="mini"
              style="margin: -4px 0 0 10px"
              >新增</el-button
            >
          </div>
          <el-table
            ref="table"
            size="mini"
            :data="XzForm.addTabData"
            :header-cell-style="{ background: '#F5F5F5', color: 'black' }"

            border
            center
            bordersize="mini"
          >
            <el-table-column label="货物类型" prop="productType" align="center">
              <template slot-scope="scope1">
                <el-select
                  filterable
                  clearable
                  v-model="scope1.row.productType"
                  size="mini"
                  placeholder="请选择货物类型"
                  @change="selectProductType(scope1.row)"
                >
                  <el-option
                    v-for="(item, index) in huowuOptions"
                    :key="index"
                    :label="item.show_name"
                    :value="item.show_name"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="控货指标" prop="zhiBiaoArr" align="center" width="200px">
              <template slot-scope="scope1">
                <el-checkbox-group v-model="scope1.row.zhiBiaoArr" @change="TonChange(scope1.row)">
                  <el-checkbox
                    v-for="(item, index) in checkZhiBiaoData"
                    :key="index"
                    :label="item.itemNo"
                    >{{ item.showName }}</el-checkbox
                  >
                </el-checkbox-group>
              </template>
            </el-table-column>
            <el-table-column label="控吨程度" prop="kongDun" align="center" width="200px">
              <template slot-scope="scope1">
                <el-radio-group v-show="scope1.row.showTon" v-model="scope1.row.kongDun">
                  <el-radio label="0">严控</el-radio>
                  <el-radio label="1">提示</el-radio>
                </el-radio-group>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
              <template slot-scope="scope1">
                <el-button
                  @click="delClick(scope1.$index, scope1.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="closeXZDialog('XzForm')">取消</el-button>
        <el-button type="primary" @click="addXZOk" :loading="XZLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>
    <!-- 查看 -->
    <el-dialog
      title="查看控货配置"
      :visible.sync="seeVisible"
      :close-on-click-modal="false"
      width="40%"
      center
      @close="closeSeeDialog"
    >
      <el-form
        :model="seeForm"
        ref="seeForm"
        label-width="110px"
        class="demo-dynamic"
      >
        <el-form-item prop="weiDuArr" label="控货纬度">
          <el-checkbox-group disabled v-model="seeForm.weiDuArr">
            <el-checkbox
              v-for="(item, index) in checkWeiDuData"
              :key="index"
              :label="item.itemNo"
              >{{ item.showName }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="!seeForm.selectGoodType" prop="zhiBiaoArr" label="控货指标">
          <el-checkbox-group v-model="seeForm.zhiBiaoArr" disabled>
            <el-checkbox
              v-for="(item, index) in checkZhiBiaoData"
              :key="index"
              :label="item.itemNo"
              >{{ item.showName }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="!seeForm.selectGoodType" prop="kongDun" label="控吨程度">
          <el-radio v-model="seeForm.kongDun" label= "0" disabled>严控</el-radio>
          <el-radio v-model="seeForm.kongDun" label= "1" disabled>提示</el-radio>
        </el-form-item>
        <div v-if="seeForm.selectGoodType" style="margin: 12px 0 13px 40px">货物类型</div>
        <el-table v-if="seeForm.selectGoodType"
          ref="table"
          size="mini"
          :data="seeForm.seeTabData"
          :header-cell-style="{ background: '#F5F5F5', color: 'black' }"
          style="width: 80%; margin-left: 40px"
          border
          center
          bordersize="mini"
        >
          <el-table-column
            label="货物类型"
            prop="goodTypeName"
            align="center"
          ></el-table-column>
          <el-table-column
            label="控货指标"
            prop="primaryCustomerName"
            align="center"
          >
          <template slot-scope="scope1">
                <el-checkbox-group disabled v-model="scope1.row.zhiBiaoArr">
                  <el-checkbox
                    v-for="(item, index) in checkZhiBiaoData"
                    :key="index"
                    :label="item.itemNo"
                    >{{ item.showName }}</el-checkbox
                  >
                </el-checkbox-group>
              </template></el-table-column>
          <el-table-column
            label="控吨程度"
            prop="secondaryCustomerName"
            align="center"
          >
            <template slot-scope="scope1">
              <el-radio-group disabled v-model="scope1.row.kongDun">
                <el-radio label="0" >严控</el-radio>
                <el-radio label="1" >提示</el-radio>
              </el-radio-group>
            </template>
        </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer">
        <el-button @click="closeSeeDialog">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getRelationCustomer,
  addOrUpdateCargoControl,
  getCargoControlList,
  deleteCargoControl,
  getDictionaryIn

} from '@/api/wms-stock'
import { getBtn } from '@/utils/getButton'
import { dateTimeFormat } from '@/utils/util'
import DonMessage from '@/utils/message'
import {
  addTGoodsControlMaster, // 新增控货客户配置
  tGoodsControlMasterList, // 列表展示
  viewGoodsControl, // 查看
  removeGoodsControl, // 删除控货客户配置
  removeMasterForWMS
} from '@/api/common-signature'
export default {
  name: 'ControlClient',
  data () {
    return {
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      btnArr: ['00FP00AB001', '00FP00AB002', '00FP00AB003', '00FP00AB004', '00FP00AB005', '00FP00AB006'],
      btnFlg: [],
      FOwnerData: [],
      searchForm: {
        oneCustomerTaxId: '',
        twoCustomerTaxId: '',
        pageNo: 1,
        pageSize: 20
      },
      tableData: [],
      total: 0,
      h: '200px',
      XzForm: {
        primaryCustomerTaxId: '',
        secondaryCustomerId: '',
        weiDuArr: [],
        zhiBiaoArr: [],
        kongDun: '1',
        addTabData: []
      },
      huowuOptions: [],
      XZVisible: false,
      XZLoading: false,
      rulesXz: {
        primaryCustomerTaxId: [
          { required: true, message: '请选择一级货主', trigger: 'change' }
        ],
        secondaryCustomerId: [
          { required: true, message: '请选择二级货主', trigger: 'change' }
        ],
        weiDuArr: [
          {
            required: true,
            message: '请至少选择一个控货纬度',
            trigger: 'change'
          }
        ],
        zhiBiaoArr: [
          {
            required: true,
            message: '请至少选择一个控货指标',
            trigger: 'change'
          }
        ],
        kongDun: [
          {
            required: true,
            message: '请至少选择一个控货程度',
            trigger: 'change'
          }
        ]
      },
      xuanzhongArr: null,
      // 查看
      seeVisible: false,
      deleteButtonOnLoading: false, // 删除按钮是否加载状态
      seeForm: {
        weiDuArr: [],
        zhiBiaoArr: [],
        kongDun: '1',
        selectGoodType: false,
        seeTabData: []
      },
      checkWeiDuData: [
        {
          showName: '产地',
          itemNo: '1'
        },
        {
          showName: '货物类型',
          itemNo: '0'
        },
        {
          showName: '材质',
          itemNo: '2'
        },
        {
          showName: '规格',
          itemNo: '3'
        },
        {
          showName: '总控',
          itemNo: '-1'
        }
      ],
      checkZhiBiaoData: [
        {
          showName: '控件',
          itemNo: '1'
        },
        {
          showName: '控吨',
          itemNo: '2'
        }
      ],
      huoWuTypeShow: false,
      zhiBIaoshow: false,
      kongDunShow: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/controlClient')
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        if (_this.XZVisible == true) {
          _this.addXZOk()
        } else {
          _this.chaxun()
        }
      }
    }
  },
  methods: {
    TonChange (row) {
      if (row.zhiBiaoArr.some(item => item == 2)) {
        row.showTon = true
      } else {
        row.kongDun = '0'
        row.showTon = false
      }
    },
    chaxun () {
      tGoodsControlMasterList(this.searchForm)
        .then((res) => {
          this.tableData = res.list
          this.total = res.total
        })
        .catch((error) => {
          this.$message({ message: error.message, type: 'error' })
        })
    },
    chongzhi () {
      this.searchForm.oneCustomerTaxId = ''
      this.searchForm.twoCustomerTaxId = ''
      this.searchForm.pageNo = 1
      this.searchForm.pageSize = 20
      this.chaxun()
    },
    xinzeng () {
      this.XZVisible = true
      this.XzForm.primaryCustomerTaxId = ''
      this.XzForm.secondaryCustomerId = ''
      this.XZLoading = false
      this.$nextTick(() => {
        this.$refs.XzForm.clearValidate()
      })
    },
    getHuowuOptions () {
      let params = {
        'groupNo': 'thread_product_type'
      }
      getDictionaryIn(params)
        .then(res => {
          this.huowuOptions = res
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    shanchu () {
      if (this.xuanzhongArr == null) {
        this.$message({ message: '请先选择一条数据', type: 'error' })
        return
      }
      // console.log(this.xuanzhongArr)
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(this.xuanzhongArr)
        this.deleteButtonOnLoading = true
        removeGoodsControl(this.xuanzhongArr.id)
          .then((res) => {
            this.deleteButtonOnLoading = false
            this.$message({ message: '删除成功', type: 'success' })
            this.chaxun()
          })
          .catch((error) => {
            this.deleteButtonOnLoading = false
            this.$message({ message: error.message, type: 'error' })
          })
      })
    },
    // 山西美景删除
    deletedClick () {
      if (this.xuanzhongArr == null) {
        this.$message({ message: '请先选择一条数据', type: 'error' })
        return
      }
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(this.xuanzhongArr)
        // this.deleteButtonOnLoading = true
        removeMasterForWMS(this.xuanzhongArr.id)
          .then((res) => {
            // this.deleteButtonOnLoading = false
            this.$message({ message: '删除成功', type: 'success' })
            this.chaxun()
          })
          .catch((error) => {
            // this.deleteButtonOnLoading = false
            this.$message({ message: error.message, type: 'error' })
          })
      })
    },
    dianjixuanzhong (row) {
      this.xuanzhongArr = {}
      this.xuanzhongArr = row
    },
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.chaxun()
    },
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.chaxun()
    },
    closeXZDialog (formName) {
      // this.$refs[formName].resetFields()
      this.XZVisible = false
      this.huoWuTypeShow = false
      this.zhiBIaoshow = false
      this.kongDunShow = false
      this.XzForm.primaryCustomerTaxId = ''
      this.XzForm.secondaryCustomerId = ''
      this.XzForm.weiDuArr = []
      this.XzForm.zhiBiaoArr = []
      this.XzForm.kongDun = ''
      this.XzForm.addTabData = []
    },
    // 控货纬度值改变
    checkedWeiDu () {
      console.log(this.XzForm.weiDuArr)
      if (this.XzForm.weiDuArr.length > 0) {
        let i = this.XzForm.weiDuArr.length - 1
        if (this.XzForm.weiDuArr[i] == '-1') {
          this.XzForm.weiDuArr = ['-1']
        } else {
          if (this.XzForm.weiDuArr.includes('-1')) {
            console.log(
              this.XzForm.weiDuArr.findIndex((item) => item == '-1'),
              '123'
            )
            this.XzForm.weiDuArr.splice(
              this.XzForm.weiDuArr.findIndex((item) => item == '-1'),
              1
            )
          }
        }
      }
      if (this.XzForm.weiDuArr.includes('0') == true) {
        this.huoWuTypeShow = true
        this.zhiBIaoshow = false
        this.kongDunShow = false
      } else {
        this.huoWuTypeShow = false
        this.zhiBIaoshow = true
      }
    },
    checkedzhiBiao (val) {
      // 选择控件不显示控吨程度
      console.log(val, 'XzForm.zhiBiaoArr')
      if (val.indexOf('2') == '-1') {
        this.kongDunShow = false
        this.XzForm.kongDun = ''
      } else {
        this.kongDunShow = true
        this.XzForm.kongDun = '0'
        console.log(this.XzForm.kongDun, 'this.XzForm.kongDun')
      }
    },
    addXZOk () {
      this.$refs.XzForm.validate((valid) => {
        if (valid) {
          this.XZLoading = true
          let params = {

          }

          params.oneCustomerName = this.FOwnerData.filter(
            (item) => item.taxpayerNumber == this.XzForm.primaryCustomerTaxId
          )[0].custerName
          params.twoCustomerName = this.FOwnerData.filter(
            (item) => item.taxpayerNumber == this.XzForm.secondaryCustomerId
          )[0].custerName
          params.oneCustomerTaxId = this.XzForm.primaryCustomerTaxId
          params.twoCustomerTaxId = this.XzForm.secondaryCustomerId
          params.productionPlace = this.XzForm.weiDuArr.includes('1') ? 1 : 0 // 控货维度之产地
          params.goodType = this.XzForm.weiDuArr.includes('0') ? 1 : 0 // 控货维度之货物类型
          params.material = this.XzForm.weiDuArr.includes('2') ? 1 : 0 // 控货维度之材质
          params.specification = this.XzForm.weiDuArr.includes('3') ? 1 : 0 // 控货维度之规格
          params.generalControl = this.XzForm.weiDuArr.includes('-1') ? 1 : 0 // 控货维度之总控
          if (!this.XzForm.weiDuArr.includes('0')) {
            let summary = {}
            // 如果选有包含货物类型
            summary.controlWeight = this.XzForm.zhiBiaoArr.includes('2') ? 1 : 0 // 控吨
            summary.controlPiece = this.XzForm.zhiBiaoArr.includes('1') ? 1 : 0 // 控件
            summary.strictReminder = this.XzForm.kongDun
            if (summary.controlWeight == 0 && summary.controlPiece == 1) {
              summary.strictReminder = 0 // 当选择控件时，控吨程度只能是严控
            }
            params.summary = summary
          } else {
            let arr = []
            if (this.XzForm.addTabData == null || this.XzForm.addTabData == undefined || this.XzForm.addTabData.length == 0) {
              this.$message({
                message: '请添加货物类型',
                type: 'error'
              })
              this.XZLoading = false
              return
            }
            let goodTypeSet = new Set()
            for (let index = 0; index < this.XzForm.addTabData.length; index++) {
              const row = this.XzForm.addTabData[index]
              let summary = {}
              summary.goodTypeName = row.productType
              if (summary.goodTypeName == null || summary.goodTypeName == undefined || summary.goodTypeName == '') {
                this.XZLoading = false
                this.$message({
                  message: `第${index + 1}条配置缺少具体的货物类型`,
                  type: 'error'
                })
                return
              }
              if (goodTypeSet.has(row.productType)) {
                this.XZLoading = false
                this.$message({
                  message: `不能选择相同的货物类型【${row.productType}】`,
                  type: 'error'
                })
                return
              } else {
                goodTypeSet.add(row.productType)
              }

              summary.controlWeight = row.zhiBiaoArr.includes('2') ? 1 : 0
              summary.controlPiece = row.zhiBiaoArr.includes('1') ? 1 : 0
              if (summary.controlWeight == 0 && summary.controlPiece == 0) {
                this.XZLoading = false
                this.$message({
                  message: `请给【${row.productType}】选择控货指标`,
                  type: 'error'
                })
                return
              }
              summary.strictReminder = row.kongDun
              if (summary.strictReminder == '') {
                this.XZLoading = false
                this.$message({
                  message: `请给【${row.productType}】选择控吨程度`,
                  type: 'error'
                })
                return
              }
              arr.push(summary)
            }
            params.summaryList = arr
          }
          console.log(params)
          addTGoodsControlMaster(params)
            .then(res => {
              this.XZLoading = false
              this.$message({ message: '添加成功', type: 'success' })
              this.closeXZDialog(this.XzForm)
              this.chaxun()
            })
            .catch(error => {
              this.XZLoading = false
              this.$message({ message: error.message, type: 'error' })
            })
        } else {
          this.XZLoading = false
        }
      })
    },
    // 货物类型
    selectProductType () {},
    addtable () {
      let obj = {
        productType: '',
        zhiBiaoArr: [],
        kongDun: '',
        showTon: false
      }
      this.XzForm.addTabData.push(obj)
    },
    delClick (index, row) {
      this.XzForm.addTabData.splice(index, 1)
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.FOwnerData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    viewClick () {
      if (this.xuanzhongArr == null || this.xuanzhongArr == undefined || this.xuanzhongArr == '') {
        this.$message({
          message: '请先选择一条数据',
          type: 'warn'
        })
        return
      }
      this.seeClick(this.xuanzhongArr)
    },
    // 查看
    seeClick (row) {
      viewGoodsControl(row.id)
        .then(res => {
          if (res.goodType == 1) {
            this.seeForm.weiDuArr.push('0')
          }
          if (res.material == 1) {
            this.seeForm.weiDuArr.push('2')
          }
          if (res.specification == 1) {
            this.seeForm.weiDuArr.push('3')
          }
          if (res.generalControl == 1) {
            this.seeForm.weiDuArr.push('-1')
          }
          if (res.productionPlace == 1) {
            this.seeForm.weiDuArr.push('1')
          }
          if (res.goodType == 1) {
            this.seeForm.selectGoodType = true
            for (let index = 0; index < res.summaryList.length; index++) {
              const row = res.summaryList[index]
              let summary = {}
              summary.goodTypeName = row.goodTypeName
              if (row.strictReminder == 0) {
                summary.kongDun = '0'
              }
              if (row.strictReminder == 1) {
                summary.kongDun = '1'
              }
              let zhiBiaoArr = []
              if (row.controlWeight == 1) {
                zhiBiaoArr.push('2')
              }
              if (row.controlPiece == 1) {
                zhiBiaoArr.push('1')
              }
              summary.zhiBiaoArr = zhiBiaoArr
              this.seeForm.seeTabData.push(summary)
            }
          } else {
            this.seeForm.selectGoodType = false
            if (res.summary.strictReminder == 0) {
              this.seeForm.kongDun = '0'
            }
            if (res.summary.strictReminder == 1) {
              this.seeForm.kongDun = '1'
            }

            if (res.summary.controlPiece == 1) {
              this.seeForm.zhiBiaoArr.push('1')
            }
            if (res.summary.controlWeight == 1) {
              this.seeForm.zhiBiaoArr.push('2')
            }
            console.log(res.summary)
          }
          this.seeVisible = true
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    },
    // 查看取消
    closeSeeDialog () {
      this.seeVisible = false
      this.seeForm.selectGoodType = false
      this.seeForm.weiDuArr = []
      this.seeForm.seeTabData = []
      this.seeForm.zhiBiaoArr = []
      this.seeTabData = []
      this.kongDun = '1'
    },
    controlIndexChange (date) { // 新增客户控货配置时，控货指标改变事件
      if (this.XzForm.zhiBiaoArr.includes('2')) {
        this.kongDunShow = true
      } else {
        this.kongDunShow = false
      }
    }
  },
  mounted () {
    this.getRelationCustomerS()
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 162 + 'px'
    this.chaxun()
    this.getHuowuOptions()
  }
}
</script>

<style lang="less" scoped>
/deep/.el-form-item {
  margin-bottom: 0
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #409EFF;
  border-color: #409EFF;
}
/deep/.el-checkbox-group .is-checked .el-checkbox__label{
  color:#409EFF !important;
}
/deep/.el-radio__input.is-disabled.is-checked .el-radio__inner {
    background-color: #409EFF;
    border-color: #409EFF;
}
/deep/.el-radio-group .is-checked .el-radio__label{
  color:#409EFF !important;
}
</style>
